<template>
  <v-container class="create-contributor">
    <v-layout row>
      <v-flex class="my-5">
        <h1>Create contributor here</h1>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex class="my-5" md6>
        <!-- List of Contributors -->

        <v-card class="halfScreen">
          <v-toolbar color="green" dark>
            <v-toolbar-title>All Contributors</v-toolbar-title>
          </v-toolbar>
          <v-list>
            <v-list-tile @click="createNew()">
              <v-list-tile-action>
                <v-icon color="primary">star</v-icon>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title v-text="'Create new contributor'"></v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-subheader inset>Existing contributors</v-subheader>
            <v-divider inset></v-divider>
            <v-list-tile
              v-for="contributor in contributors"
              :key="contributor.uri"
              @click="openContributor(contributor.uri)"
            >
              <v-list-tile-action>
                <v-avatar size="40" color="grey lighten-4" v-if="contributor.imageDisplay">
                  <img :src="contributor.imageDisplay" alt="Avatar image preview." />
                </v-avatar>
                <v-avatar size="40" color="grey lighten-4" v-if="!contributor.imageDisplay">
                  <v-icon color="primary">account_circle</v-icon>
                </v-avatar>
              </v-list-tile-action>
              <v-list-tile-content>
                <v-list-tile-title v-text="contributor.displayName"></v-list-tile-title>
                <v-list-tile-sub-title v-text="contributor.role"></v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-card>
      </v-flex>

      <v-flex md6 class="my-5">
        <!-- Form input -->

        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container>
            <v-layout row wrap>
              <v-flex sm12>
                <v-text-field v-model="form.displayName" label="Name the person" required></v-text-field>

                <v-text-field v-model="form.role" label="Role" required></v-text-field>

                <v-layout row wrap>
                  <v-flex xs9 class="text-xs-center text-sm-center text-md-center text-lg-center">
                    <v-text-field
                      label="Thumbnail Image"
                      @click="pickFile('imageDisplay')"
                      v-model="imageDisplay.name"
                      prepend-icon="attach_file"
                    ></v-text-field>
                    <input
                      type="file"
                      style="display: none"
                      ref="imageDisplay"
                      id="imageDisplay"
                      accept="image/*"
                      @change="onFilePicked"
                    />
                  </v-flex>
                  <v-flex xs3 class="text-xs-center text-sm-center text-md-center text-lg-center">
                    <v-avatar size="50" color="grey lighten-4" v-if="imageDisplay.url">
                      <img :src="imageDisplay.url" alt="Avatar image preview." />
                    </v-avatar>
                    <v-avatar size="50" color="grey lighten-4" v-if="!imageDisplay.url">
                      <v-icon color="primary">account_circle</v-icon>
                    </v-avatar>
                  </v-flex>
                </v-layout>

                <v-btn :disabled="!valid" @click="validate" color="green">Validate</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style lang="scss">
.create-contributor {
  display: inherit;
}
</style>

<script>
import { db, storage } from '@/db.js'
import camelCase from 'lodash.camelcase'
import cloneDeep from 'lodash.clonedeep'

export default {
  name: 'createContributor',
  data () {
    return {
      contributors: [],
      form: {
        displayName: '',
        role: '',
        imageDisplay: '',
        uri: ''
      },
      imageDisplay: {
        name: '',
        url: '',
        file: ''
      },
      valid: true
    }
  },
  firestore: {
    contributors: db.collection('contributors')
  },
  created () {
    let vm = this
    vm.getContributor()
  },
  methods: {
    triggerSnackbar (text) {
      this.$store.dispatch('setsnackbarOptions', {
        text: text
      })
    },
    openContributor (contributorUri) {
      this.handleLink(`/admin/createContributor/${contributorUri}`)
      this.getContributor(contributorUri)
      this.reset()
    },
    getContributor (contributorUri) {
      let vm = this

      if (this.$route.params.id || contributorUri) {
        this.uri = this.$route.params.id || contributorUri

        db.collection('contributors')
          .doc(this.uri)
          .get()
          .then(response => {
            vm.form = response.data() || {}
            vm.imageDisplay.url = vm.form.imageDisplay || ''
          })
          .catch(error => {
            throw new Error(error)
          })
      }
    },
    createNew () {
      this.reset()
      this.handleLink(`/admin/createContributor`)
    },
    reset () {
      this.$refs.form.reset()
      this.form.uri = ''
      this.imageDisplay.name = ''
      this.imageDisplay.url = ''
      this.imageDisplay.file = ''
      this.$refs.form.resetValidation()
    },
    validate () {
      if (this.$refs.form.validate()) {
        this.sendForm()
      }
    },
    sendForm () {
      let vm = this
      let formPayload = cloneDeep(vm.form)

      if (formPayload.uri.length === 0) {
        formPayload.uri = encodeURIComponent(
          camelCase(formPayload.displayName)
        )

        formPayload.uri += Math.floor(Math.random() * 1000).toString()

        formPayload.uri += Date.now().toString()
      }

      // vm.sendFormImages(formPayload)

      if (!vm.imageDisplay.name) {
        vm.sendFormPayload(formPayload)
      } else if (vm.imageDisplay.name) {
        vm.sendFormImages(formPayload)
      }
    },
    sendFormImages (formPayload) {
      let vm = this
      let fileExtension = vm.imageDisplay.name
        .split('.')
        .slice(-1)
        .pop()

      storage
        .images(formPayload.uri + '_displayImage' + '.' + fileExtension)
        .put(vm.imageDisplay.file)
        .then(snapshot => snapshot.ref.getDownloadURL())
        .then(url => {
          formPayload.imageDisplay = url
          vm.sendFormPayload(formPayload)
        })
        .catch(error => {
          vm.statusText = error
        })
    },
    onFilePicked (e) {
      const target = e.path['0'].id
      const files = e.target.files
      if (files[0] !== undefined && files[0].type.match(/image.*/)) {
        this[target].name = files[0].name
        if (this[target].name.lastIndexOf('.') <= 0) {
          return
        }
        const fr = new FileReader()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this[target].url = fr.result
          this[target].file = files[0] // this is an image file that can be sent to server...
          // TODO
          // this.resizePhoto(fr.result)
        })
      } else {
        this[target].name = ''
        this[target].file = ''
        this[target].url = ''
      }
    },
    sendFormPayload (formPayload) {
      let vm = this

      db.collection('contributors')
        .doc(formPayload.uri)
        .set(formPayload, {
          merge: true
        })
        .then(() => {
          vm.triggerSnackbar('Successful write to database')
        })
        .catch(error => {
          vm.triggerSnackbar('Failed to update to database:' + error)
        })
    },
    pickFile (ref) {
      this.$refs[ref].click()
    },
    handleLink (url) {
      let urlPattern = new RegExp(
        '^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$' + // fragment locator
          '',
        'i' + '' // string to match
      )
      const isUrl = urlPattern.test(url)

      if (isUrl) {
        window.open(url)
      } else {
        this.$router.push(url)
      }
    }
  }
}
</script>
